import app from 'flarum/forum/app';

export default function sectionName(section) {
  if (section && section.nameKey) {
    const translated = app.translator.trans(section.nameKey);
    if (translated && translated !== section.nameKey) {
      return translated;
    }
  }
  return section ? section.name : '';
}